'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const getPropsIcon = (icon) => {
  const style = {};
  if (icon == null ? void 0 : icon.color) {
    style.color = icon.color;
  }
  if (icon == null ? void 0 : icon.size) {
    style.fontSize = icon.size;
  }
  return { style };
};

exports.getPropsIcon = getPropsIcon;
